import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./Specific.scss";
import { ProductDetails } from "./ProductDetails";
import { Reviews } from "./Reviews";
import { SimilarProducts } from "../SimilarProducts";
import { ProductSliderMultiSpecific } from "../../Components/images/Mob/ProductSliderMultiSpecific";
import { ProductsMobNew } from "../../Products/Mobile/ProductsMobNew";
import { isAndroid } from "react-device-detect";

import { API_BASE_URL } from '../../config';
import { PRODUCT_REVIEW_SUBMITTED } from '../../utils/productReviewEvents';
import { PHONE_CASE_CATEGORY } from "../../Products/data/phoneCaseFilters";
import { ensureMediaUrl } from '../../utils/mediaUrl';
const BASE_URL = API_BASE_URL;

// Build one slide row of 7 image URLs from product urls (pad or trim as needed)
function buildSlidesFromProduct(product) {
  const raw = product?.urls || [];
  const urls = raw.map((u) => ensureMediaUrl(u)).filter(Boolean);
  if (urls.length === 0) return [];
  const need = 7;
  const slide = [];
  for (let i = 0; i < need; i++) slide.push(urls[i % urls.length]);
  return [slide];
}

export function MobSpecific() {
  const { product_id } = useParams();
  const [product, setProduct] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [heroImageReady, setHeroImageReady] = useState(false);
  const [productRefreshKey, setProductRefreshKey] = useState(0);

  useEffect(() => {
    setHeroImageReady(false);
  }, [product_id]);

  const handleHeroImageReady = useCallback(() => {
    setHeroImageReady(true);
  }, []);

  useEffect(() => {
    const onReviewSubmitted = (e) => {
      if (String(e.detail?.productId) === String(product_id)) {
        setProductRefreshKey((k) => k + 1);
      }
    };
    window.addEventListener(PRODUCT_REVIEW_SUBMITTED, onReviewSubmitted);
    return () => window.removeEventListener(PRODUCT_REVIEW_SUBMITTED, onReviewSubmitted);
  }, [product_id]);

  useEffect(() => {
    if (!product_id) return;
    setFetching(true);
    let cancelled = false;
    const token = localStorage.getItem("token");
    const config = { headers: token ? { Authorization: `Bearer ${token}` } : {} };
    axios
      .post(
        `${BASE_URL}/products/specifications/${product_id}`,
        {},
        config
      )
      .then((res) => {
        if (!cancelled) setProduct(res.data || null);
      })
      .catch((err) => {
        if (!cancelled) setProduct(null);
        console.error("Failed to fetch product specifications:", err);
      })
      .finally(() => {
        if (!cancelled) setFetching(false);
      });
    return () => { cancelled = true; };
  }, [product_id, productRefreshKey]);

  const slides = product ? buildSlidesFromProduct(product) : [];
  const hasSlides = slides.length > 0;
  const showHeroLoader = fetching || (hasSlides && !heroImageReady);

  return (
    <div className="specific-mob">
      <div className="top-section">
        {(fetching || hasSlides) ? (
          <div className="specific-mob-hero">
            {hasSlides ? (
              <ProductSliderMultiSpecific
                slides={slides}
                product={product}
                onFirstImageLoad={handleHeroImageReady}
                suppressImagePlaceholders={showHeroLoader}
              />
            ) : (
              <div className="specific-mob-hero__placeholder" aria-hidden>
                <div className="specific-mob-hero__placeholder-media" />
                <div className="specific-mob-hero__placeholder-footer" />
              </div>
            )}

            {showHeroLoader && (
              <div
                className="specific-mob-image-loading specific-mob-image-loading--hero-overlay"
                role="status"
                aria-live="polite"
                aria-busy="true"
              >
                <div className="specific-mob-image-loading__plate">
                  <div className="specific-mob-image-loading__center">
                    <div className="specific-mob-image-loading__spinner" aria-hidden />
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="prod-right-details" style={{ padding: "1rem" }}>
            Product not found or no images.
          </div>
        )}

        <div className="cardification"></div>

        <div className="prod-right-details">
          <ProductDetails product_id={product_id} initialProduct={product} />
        </div>
      </div>

      <div className="review-section">
        <Reviews product_id={product_id} />
      </div>

      <div className="similar-products">
        <SimilarProducts
          excludeProductId={product_id}
          category={product?.category || PHONE_CASE_CATEGORY}
          subcategory={product?.subcategory}
          title="You may also like"
        />
      </div>

      <div className="all-products">
        <header className="all-products__header">
          <h2 className="all-products__title">All products</h2>
        </header>
        <ProductsMobNew
          hideOptions={true}
          mobileCardVariant={isAndroid ? "translateStrip" : "stacked"}
        />
      </div>
    </div>
  );
}
